<template>
  <app-form
    class="domain-authenticate-form-domain"
    @submit="authenticateDomain"
  >
    <p class="domain-authenticate-form-domain-text">
      {{ $t("message.email.message.domainValidationHint") }}
    </p>

    <text-field
      v-model="form.domain"
      :label="$t('message.email.message.domainToUse')"
      validate="required"
    />

    <text-field
      v-model="form.subdomain"
      :label="$t('message.email.message.subdomain')"
      :help="$t('message.email.message.subdomainHint')"
      v-show="false"
    />

    <app-button
      class="domain-authenticate-form-domain-actions btn btn-extra-round btn-primary"
      :loading="loading"
      :label="$t('message.marketingGenerics.message.nextStep')"
      type="submit"
    />
  </app-form>
</template>

<script>
import TextField from "@components/form/TextField";
import AppForm from "@components/form/Form";
import AppButton from "@/components/generic/button/Button";

export default {
  components: {
    AppForm,
    TextField,
    AppButton,
  },

  data() {
    return {
      form: {
        domain: "",
        subdomain: "",
      },
      loading: false,
    };
  },

  props: {},

  created() {},

  computed: {},

  watch: {},

  methods: {
    async authenticateDomain() {
      try {
        this.loading = true;
        const domain = await this.$api.marketing.email.dns.authenticate({
          domain: this.form.domain,
          subdomain: this.form.subdomain,
        });

        this.$emit("submit", domain);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.domain-authenticate-form-domain {
  .domain-authenticate-form-domain-text {
    margin-bottom: 24px;
  }

  .domain-authenticate-form-domain-actions {
    margin: 0 auto;
  }
}
</style>
